import { useQuery } from "react-query";
import { restServices } from "cuba/services";

/**
 * Запрос в сервис employeeService для получения профиля сотрудника по personGroupId
 */
const fetchPersonGroup = async (personGroupId: string) => {
  return await restServices.employeeService.personProfile(personGroupId);
};

interface UsePersonProfileArgs<T extends boolean = false> {
  personGroupId?: string;
  asArray?: T;
}

/**
 * Хук для загрузки данных профиля сотрудника по personGroupId
 * @param args - объект с параметрами (personGroupId, asArray)
 */
export const usePersonProfile = <T extends boolean = false>(
  args: UsePersonProfileArgs<T>,
) => {
  const { personGroupId, asArray } = args;

  return useQuery({
    queryKey: ["personGroup", personGroupId, asArray],
    queryFn: async () => {
      const res = await fetchPersonGroup(personGroupId!);
      const changedRes = {
        ...res,
        id: res?.groupId,
        _instanceName: res?.fullName,
      };
      return (asArray ? [changedRes] : changedRes) as T extends true
        ? (typeof changedRes)[]
        : typeof changedRes;
    },
    enabled: !!personGroupId,
    retry: false,
    refetchOnWindowFocus: false,
    onError: (error) => {
      console.error("❌ Ошибка загрузки данных personGroup:", error);
    },
  });
};
